module.exports = __webpack_public_path__ + "img/a3-s62.855c49de.jpg";